import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Box, Typography } from '@mui/material';
export const WalletInfoDisplay = ({ selectedWallet, title, message, }) => {
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            px: 1,
        }, children: [selectedWallet && (_jsx(Avatar, { src: selectedWallet.icon, alt: selectedWallet.name, sx: { width: 96, height: 96 }, children: selectedWallet.name[0] })), title && (_jsx(Typography, { sx: {
                    pt: 2,
                    fontSize: '16px',
                    lineHeight: '24px',
                    fontWeight: 700,
                    textAlign: 'center',
                }, children: title })), _jsx(Typography, { variant: "body2", sx: {
                    pt: 2,
                    fontSize: '16px',
                    lineHeight: '24px',
                    fontWeight: 500,
                    textAlign: 'center',
                }, children: message })] }));
};
//# sourceMappingURL=WalletInfoDisplay.js.map